import React from 'react'
import { useHistory } from "react-router-dom"
import "./enteral.css";
import Header from "./Header"
import Footer from "./Footer"

function ActionPlan() {
    let history = useHistory();
    const home = () => {
        history.push("/")
        localStorage.clear();
    }
    return (
        <div className="row">
        <div className="col-md-12">
        <div className= "enteral__page">
        <Header/>
        <div className = "enteral__content">
            <form>
            <div>
            <div className = "recommended__word">Recommended action plan</div>
            <label>1. Add HMF. Please select the ratio of HMF</label>
            <label> <button className = "breastmilk_button">1:25</button> <button className = "breastmilk_button">1:25</button> </label>
            <div className = "ml__kg__day">ml/kg/day</div>
            <label>2. Please increase feeding rate to <button className ="increase__feed">170.0</button></label>
            <div className = "ml__kg__day">g/day</div>
            <label>3. Whey protein per day <button className = "whey__perday">1.0</button></label>
            </div>
            <div className = "line__action"/>
            <div className = "infant__achieve">
                <label>With this, infant will be achieving:</label>
                <div className = "kcals__kg">
                <label>kcals/kg</label>   
                <label className ="kcals__kg2" >kl/kg</label>  
                </div>
                <label>Energy <button className = "energy__perday">110-115</button> <button className = "energy__perday">4.70/481</button></label>
                <div className = "ml__kg__day">
                <label> g/kg/day</label>
                </div>
                <label>Protein <button className = "protein__perday">3.9-4.1</button></label>
            </div>
            <button className = "goto__home" onClick={home}>Homepage</button>
            </form>
            </div>
             </div>
            </div>
        </div>
    )
}

export default ActionPlan
